import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";
export const processService = {
  create: async (profileId, processData, token) => {
    const response = await https.post(
      `${API_ROUTES.PROCESS.CREATE}/${profileId}/processes`,
      processData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  delete: async (profileId, processId, token) => {
    const response = await https.delete(
      `${API_ROUTES.PROCESS.DELETE}/${profileId}/processes/${processId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  },
  update: async (processId, processData, token) => {
    const response = await https.put(
      `${API_ROUTES.PROCESS.CREATE}/${processId}`,
      processData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
};
